import filterAPI from "../api/filterAPI";
import { ActionTypesScreen3 } from "app/constants";

export function fetchIndustryData() {
    return (dispatch) => {
      filterAPI
        .getAllIndustryNamesScreen3()
        .then((res) => {
          let industryData = res.data.data;
          dispatch(handleIndustryData(industryData));
        })
        .catch((e) => {
          console.log(e);
        });
    };
  }
  
function handleIndustryData(data) {
    return {
        type: ActionTypesScreen3.GET_INDSUTRY_DATA,
        payload: data,
    };
}

export function fetchAverageDataScreen3(region_name, naics_dropdown_value) {
  return (dispatch) => {
    filterAPI
      .getAverageDetailsScreen3({"region_name": region_name, "naics_dropdown_value": naics_dropdown_value })
      .then((res) => {
        let averageDataScreen3 = res.data.data;
        dispatch(handleAverageDataScreen3(averageDataScreen3));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleAverageDataScreen3(data) {
  return {
    type: ActionTypesScreen3.GET_AVERAGE_DATA_SCREEN3,
    payload: data,
  };
}

export function fetchAgeData(region_name, naics_dropdown_value, occupation_dropdown_value) {
  return (dispatch) => {
    filterAPI
      .getAgeDetailsScreen3({"region_name": region_name, "naics_dropdown_value": naics_dropdown_value, "occupation_dropdown_value": occupation_dropdown_value })
      .then((res) => {
        let ageData = res.data.data;
        dispatch(handleAgeData(ageData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleAgeData(data) {
  return {
    type: ActionTypesScreen3.GET_AGE_DATA,
    payload: data,
  };
}

export function fetchRaceData(region_name, naics_dropdown_value, occupation_dropdown_value) {
  return (dispatch) => {
    filterAPI
      .getRaceDetailsScreen3({"region_name": region_name, "naics_dropdown_value": naics_dropdown_value, "occupation_dropdown_value": occupation_dropdown_value })
      .then((res) => {
        let raceData = res.data.data;
        dispatch(handleRaceData(raceData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleRaceData(data) {
  return {
    type: ActionTypesScreen3.GET_RACE_DATA,
    payload: data,
  };
}

export function fetchGenderData(region_name, naics_dropdown_value, occupation_dropdown_value) {
  return (dispatch) => {
    filterAPI
      .getGenderDetailsScreen3({"region_name": region_name, "naics_dropdown_value": naics_dropdown_value, "occupation_dropdown_value": occupation_dropdown_value })
      .then((res) => {
        let genderData = res.data.data;
        dispatch(handleGenderData(genderData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleGenderData(data) {
  return {
    type: ActionTypesScreen3.GET_GENDER_DATA,
    payload: data,
  };
}

export function fetchRegionalConcentrationData(naics_dropdown_value) {
    return (dispatch) => {
      filterAPI
        .getRegionalConcentrationDetailsScreen3({ "naics_dropdown_value": naics_dropdown_value })
        .then((res) => {
          let regionalConcentrationData = res.data.data;
          dispatch(handleRegionalConcentrationData(regionalConcentrationData));
        })
        .catch((e) => {
          console.log(e);
        });
    };
  }
  
function handleRegionalConcentrationData(data) {
    return {
        type: ActionTypesScreen3.GET_REGIONAL_CONCENTRATION_DATA,
        payload: data,
    };
}

export function fetchRegionalMigrationData(naics_dropdown_value) {
    return (dispatch) => {
      filterAPI
        .getRegionalMigrationDetailsScreen3({ "naics_dropdown_value": naics_dropdown_value })
        .then((res) => {
          let regionalMigrationData = res.data.data;
          dispatch(handleRegionalMigrationData(regionalMigrationData));
        })
        .catch((e) => {
          console.log(e);
        });
    };
  }
  
function handleRegionalMigrationData(data) {
    return {
        type: ActionTypesScreen3.GET_REGIONAL_MIGRATION_DATA,
        payload: data,
    };
}

export function updateJobTypeS3(quality_of_jobs) {
  return (dispatch) => {
    dispatch(setJobTypeS3(quality_of_jobs));
  };
}

function setJobTypeS3(data) {
  return {
    type: ActionTypesScreen3.SET_SELECTED_JOB_TYPE_S3,
    payload: data,
  };
}

export function updateIndustryTypeS3(industry) {
  return (dispatch) => {
    dispatch(setIndustryTypeS3(industry));
  };
}

function setIndustryTypeS3(data) {
  return {
    type: ActionTypesScreen3.SET_SELECTED_INDUSTRY_TYPE_S3,
    payload: data,
  };
}
